import React from "react";
import {
  FormControlLabel,
  styled,
  Switch,
  type FormControlLabelProps,
  type SwitchProps,
} from "@mui/material";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 4,
    transition: "transform 200ms ease",
  },

  "& .MuiSwitch-thumb": {
    width: 26,
    height: 26,
    backgroundColor: "var(--neutral-white)",
    boxShadow: "none",
  },

  "& .MuiSwitch-track": {
    backgroundColor: "var(--neutral-500)",
    opacity: 1,
    borderRadius: "var(--radius-round)",
    position: "relative",
    transition: "background-color 200ms ease",

    "&::before, &::after": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: 10,
      fontWeight: 600,
      pointerEvents: "none",
      transition: "opacity 200ms ease",
    },

    /* YES (hidden when OFF) */
    "&::before": {
      content: '"YES"',
      left: 10,
      color: "var(--neutral-white)",
      opacity: 0,
    },

    /* NO (visible when OFF) */
    "&::after": {
      content: '"NO"',
      right: 10,
      color: "var(--neutral-700)",
      opacity: 1,
    },
  },

  /* ON STATE */
  "& .MuiSwitch-switchBase.Mui-checked": {
    transform: "translateX(28px)",
  },

  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: (theme.vars || theme).palette.primary.dark,
    opacity: 1,

    "&::before": {
      opacity: 1,
    },

    "&::after": {
      opacity: 0,
    },
  },

  /* DISABLED STATE */
  "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: "var(--neutral-200)",
    opacity: 1,
  },
}));

type RpMuiSwitchProps = SwitchProps & {
  label?: React.ReactNode;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
};

function RpMuiSwitch({ label, labelPlacement, ...props }: RpMuiSwitchProps) {
  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPlacement}
      sx={{ ml: 0 }}
      control={
        <CustomSwitch
          {...props}
          slotProps={{ input: { "aria-label": "Yes No switch" } }}
        />
      }
    />
  );
}

export default RpMuiSwitch;
